export enum LanguageCode {
  NL = "nl",
  EN = "en-gb"
}

export interface ILanguageState {
  activeLanguage: LanguageCode;
}
